import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { ReviewsBar } from './components/ReviewsBar';
import { Problems } from './components/Problems';
import { BasketballReadyStats } from './components/BasketballReadyStats';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { CountdownSection } from './components/CountdownSection';
import { Pricing } from './components/Pricing';
import { ProTacticalKit } from './components/ProTacticalKit';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '1746177603324330';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <div className="w-full bg-ink font-sans" data-id="element-0" data-mp="23utas12ahw9q">
      <OfferBar data-id="element-1" data-mp="3ik7g4ghnibqn" />
      <Hero data-id="element-2" data-mp="3ikqzm1my986s" />
      <main data-id="element-3" data-mp="3iiwfuqnezm4a">
        <ReviewsBar data-id="element-4" data-mp="3ijfx0558q6h9" />
        <Problems data-id="element-5" data-mp="3ihv048vgebg8" />
        <BasketballReadyStats data-id="element-6" data-mp="3mlj82snzz920" />
        <Volumes data-id="element-7" data-mp="3mkrgdsxitvh0" />
        <Bonuses data-id="element-8" data-mp="3mk83iqmq9x9u" />
        <CountdownSection data-id="element-9" data-mp="3mjpyb4i388ps" />
        <Pricing data-id="element-10" data-mp="3rc9co3oln7vn" />
        <ProTacticalKit data-id="element-11" data-mp="3rbrc4uuwm7hx" />
        <Testimonials data-id="element-12" data-mp="3rdkgg3i1ofmr" />
        <Guarantee data-id="element-13" data-mp="3rd17vdeab3le" />
        <Faq data-id="element-14" data-mp="5yjsutqtdfe" />
        <FinalCta data-id="element-15" data-mp="5os92t1uy7l" />
      </main>
      <Footer data-id="element-16" data-mp="4n4bxqxqh8g" />
    </div>;
}